export default __webpack_public_path__ + "static/out_sourcing2-883ca000d83e69660f9bf7b9d57dc2ce.jpg";